import MicroModalSelectorSearch, { CustomViewPickerRender } from "../../../../common/components/organisme/MicroModalSelectorSearch/MicroModalSelectorSearch";
import { Station } from "../../types/stations.types";
import useQuerySelector from "../../../../common/hooks/useQuerySelector";
import { ResponseAPIWithPagination } from "../../../../utils/genericAPI/API.types";
import stationAPI from "../../services/stationsAPI";

export interface StationPickerProps {
  currentStation?: Station;
  setCurrentStation: (station: Station | undefined) => void;
  isError?: boolean;
  style?: React.CSSProperties;
  customViewRender?: CustomViewPickerRender;
  label?: string;
  placeholder?: string;
}

export default function StationPicker({
  currentStation,
  setCurrentStation,
  isError,
  placeholder = "Sélectionner une station",
  ...otherProps
}: StationPickerProps) {
  const { resultFound, isLoading, setValueQuery, valueQuery, isLoadingMore, setPage, lastPage, page  } =
    useQuerySelector<ResponseAPIWithPagination<Station>>({
      getSearch: (query: string, page, pageSize) => {
        return stationAPI.getAll({ search: query, page, pageSize });
      },
      addMoreResult(prev, next) {
        return {
          ...next.data,
          data: [...prev.data, ...next.data],
        };
      },
      extractLastPage: (result) =>
        result.pagination.total_pages,
      pageSize: 4,
    });

  return (
    <MicroModalSelectorSearch
    {...otherProps}
      valueSelectedName={currentStation?.station_name}
      placeholder={placeholder}
      valueQuery={valueQuery}
      setQuery={setValueQuery}
      result={
        resultFound?.data
          ? resultFound?.data?.map((item) => ({
              id: item.station_id,
              name: item.station_name,
              item,
            }))
          : []
      }
      onClickItem={(item) => {
        setCurrentStation(item.item);
      }}
      isLoading={isLoading}
      isError={isError}
      iconType="electricStation"
      isLoadingMore={isLoadingMore}
      setPage={setPage}
      lastPage={lastPage || undefined}
      currentPage={page}
    />
  );
}
